import React, {FC} from 'react';
import IdentityPageLayout from "@/features/identity/components/IdentityPageLayout.tsx";
import {useNavigate, useParams} from 'react-router-dom';
import {Button} from "@/components/ui/button.tsx";
import {useTranslation} from "react-i18next";

const AuthorizationMessagePage: FC = () => {
    const {type} = useParams<{ type: "forgotPassword" | "setPassword" }>();
    const navigate = useNavigate();
    const {t} = useTranslation();

    const getMessage = () => {
        switch (type) {
            case 'forgotPassword':
                return 'A password reset link has been sent to your email.';
            case 'setPassword':
                return 'Your password has been successfully set. You can now log in.';
            default:
                return 'An unexpected error occurred. Please try again later.';
        }
    }

    return (
        <IdentityPageLayout>
            <div className={"flex flex-col gap-2 items-center justify-center px-8 py-14 rounded-2.5xl bg-popover-10"}>
                <div>{getMessage()}</div>
                <div>
                    <Button
                        onClick={() => navigate("/auth/login")}
                        type='button'
                        variant='link'
                        className='p-0 hover:text-popover-800 active:text-popover-600'>
                        {t('elements.buttons.login')}
                    </Button>
                </div>
            </div>
        </IdentityPageLayout>
    );
};

export default AuthorizationMessagePage;